export default __webpack_public_path__ + "static/media/hero-man.fc7a5812.jpg";